import styled from 'styled-components';
import {IoMdHome} from 'react-icons/io';

export const Iohome = styled(IoMdHome)`
  color: #2DDC06;
`
